/**
 * Formats Kazakh phone number to display format
 * Converts 77014567825 to +7 701 456 78 25
 */
export function formatPhone(phone: any): string {
  const phoneStr = String(phone || '').trim()

  if (phoneStr.length === 11 && phoneStr.startsWith('77') && /^\d+$/.test(phoneStr)) {
    return `+7 ${phoneStr.slice(1, 4)} ${phoneStr.slice(4, 7)} ${phoneStr.slice(7, 9)} ${phoneStr.slice(9)}`
  }

  return phoneStr
}